import { connect } from 'react-redux';
import { selectors as inboxSelectors } from '../../../../store/conversations';
import ConversationDescription from './ConversationDescription';

const mapStateToProps = (state, { conversationId }) => ({
  title: inboxSelectors.conversationTitle(state, conversationId),
});

export default connect(mapStateToProps)(ConversationDescription);
